// dependencies imports ⇒
import React, { useState } from "react";
import Select, { components } from "react-select";
// assets and scss imports ⇒
import deleteIcon from "../../../assets/delete_icon_pre.svg";
import plusIcon from "../../../assets/plus-icon.svg";
import closeIcon from "../../../assets/forhomepage/close_icon.svg";
import "./paymentMethods.scss";
// project file imports(UI components) ⇒
// const file imports(helper methods, etc) ⇒
import { PAYMENT_DETAILS, PAYMENT_OPTIONS } from "../constants";
import { getPaidAmountRefund } from "../helper";

const PaymentMenthods = (props) => {
  const {
    hidePaymentMode,
    multiplePaymentList,
    totalPendingAmount,
    totalAmountPaid,
    totalFees,
    hasPartialAmount,
    totalPaidPartialAmount,
    totalPaidFullAmount,
    appointmentDetails,
    updateMultiplePaymentList,
  } = props;

  const [pendingAmountPopulated, setPendingAmountPopulated] = useState(false);

  // Actions ⇒
  const handleAddPayment = () => {
    let paymentList = [...multiplePaymentList];
    let filteredList = paymentList?.filter((data) => !data?.is_deleted);
    if (filteredList?.length < 10) {
      filteredList.push({ ...PAYMENT_DETAILS, isSave: false });
      updateMultiplePaymentList(filteredList);
    }
  };

  const handleDeletePayment = (index) => {
    let paymentList = [...multiplePaymentList];
    paymentList = paymentList?.filter((data) => !data?.is_deleted);
    paymentList.splice(index, 1);
    let filteredPaymentList = paymentList?.filter(
      (paymentData) => !paymentData?.isSave
    );

    if (filteredPaymentList?.length === 0) {
      setPendingAmountPopulated(false);
    }
    updateMultiplePaymentList(paymentList);
  };

  const handleAmount = (e, index) => {
    let decimalValues = e.target.value.split(".")[1];
    if (!decimalValues || decimalValues?.length <= 2) {
      let paymentList = [...multiplePaymentList];
      paymentList = paymentList?.filter((data) => !data?.is_deleted);
      paymentList[index].amount = e.target.value;
      updateMultiplePaymentList(paymentList);
    }
  };

  const handleTransactionId = (e, index) => {
    let paymentList = [...multiplePaymentList];
    paymentList = paymentList?.filter((data) => !data?.is_deleted);
    paymentList[index].transaction_id = e.target.value;
    updateMultiplePaymentList(paymentList);
  };

  const handleSelect = (selectedValue, index) => {
    let paymentList = [...multiplePaymentList];
    paymentList = paymentList?.filter((data) => !data?.is_deleted);
    let filteredList = paymentList?.filter(
      (paymentData) =>
        !paymentData?.isSave &&
        selectedValue?.value &&
        paymentData?.payment_method === selectedValue?.value
    );
    if (filteredList?.length == 0) {
      let filteredPaymentList = paymentList?.filter(
        (paymentData) => !paymentData?.isSave && selectedValue?.value
      );

      setPendingAmountPopulated(true);

      let amount = "";

      if (filteredPaymentList?.length !== 0) {
        amount =
          !paymentList[index].amount &&
          !pendingAmountPopulated &&
          totalPendingAmount > 0
            ? totalPendingAmount
            : paymentList[index].amount ?? "";
      }

      if (selectedValue?.value === "Other") {
        paymentList[index].payment_method = "";
        paymentList[index].specify_other = true;
        paymentList[index].amount = amount;
      } else {
        paymentList[index].payment_method = selectedValue?.value;
        paymentList[index].amount = amount;
      }

      updateMultiplePaymentList(paymentList);
    }
  };

  const handleCloseSpecifyOther = (index) => {
    let paymentList = [...multiplePaymentList];
    paymentList = paymentList?.filter((data) => !data?.is_deleted);
    paymentList[index].specify_other = false;
    paymentList[index].payment_method = "";
    updateMultiplePaymentList(paymentList);
  };

  const handleSpecifyOtherPamentChange = (e, index) => {
    let paymentList = [...multiplePaymentList];
    paymentList = paymentList?.filter((data) => !data?.is_deleted);
    paymentList[index].payment_method = e.target.value;
    updateMultiplePaymentList(paymentList);
  };

  // create UI ⇒
  const DropdownIndicator = (property) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...property}>
          {property.selectProps.menuIsOpen ? (
            <i className="fa fa-caret-up" style={{ color: "#17bae0" }}></i>
          ) : (
            <i className="fa fa-caret-down" style={{ color: "#17bae0" }}></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };

  const paymentMethods = () => {
    let refundAmount = getPaidAmountRefund(
      totalAmountPaid,
      totalFees,
      totalPaidPartialAmount,
      appointmentDetails
    );
    let filteredPaymentMethod = multiplePaymentList?.filter(
      (data) => !data?.is_deleted
    );
    let onlineViaC2C = {
      id: 9,
      value: "Online Via C2C",
      label: "Online Via C2C",
    };
    return (
      <>
        {filteredPaymentMethod.map((data, idx) => {
          return (
            <div key={idx} className="payment-method-type-wrapper">
              <div
                className={
                  "custom-payment-selector " +
                  (data?.isSave || data?.isOnline
                    ? "disable-select-container"
                    : "")
                }
              >
                {!data?.specify_other ? (
                  <Select
                    className={
                      "select_style " +
                      (data?.isSave || data?.isOnline
                        ? "disable-select-input"
                        : "")
                    }
                    onChange={(e) => handleSelect(e, idx)}
                    value={
                      data?.isOnline
                        ? onlineViaC2C
                        : PAYMENT_OPTIONS.filter((option) => {
                            return (
                              option.value &&
                              option.value === data?.payment_method
                            );
                          })
                    }
                    placeholder="Select Payment Method"
                    options={PAYMENT_OPTIONS}
                    components={{ DropdownIndicator }}
                    isDisabled={data?.isSave || data?.isOnline}
                    isOptionDisabled={(option) =>
                      multiplePaymentList.some(
                        (payment) =>
                          !payment.isSave &&
                          option?.value &&
                          payment.payment_method == option?.value
                      )
                    }
                  />
                ) : (
                  <div className="search-wrapper">
                    <input
                      type="text"
                      className={
                        "inputSearch " +
                        (data?.isSave ? "disable-payment-input" : "")
                      }
                      value={data?.payment_method}
                      placeholder="Specify Other"
                      onChange={(e) => {
                        handleSpecifyOtherPamentChange(e, idx);
                      }}
                      disabled={data?.isSave}
                    />
                    <img
                      src={closeIcon}
                      alt="close"
                      style={{
                        cursor: data?.isSave ? "not-allowed" : "pointer",
                      }}
                      onClick={() => {
                        if (!data?.isSave) {
                          handleCloseSpecifyOther(idx);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="transaction-amount-wrapper">
                <div className="transction-ammount-inputs-wrapper">
                  <input
                    onChange={(e) => handleTransactionId(e, idx)}
                    type="text"
                    className={
                      "payment-inputsearch " +
                      (data?.isSave || data?.isOnline
                        ? "payment-input-disabled"
                        : "")
                    }
                    value={data?.transaction_id}
                    placeholder="Transaction ID"
                    disabled={data?.isSave || data?.isOnline}
                  />
                </div>
                <div className="amount-btns-wrapper">
                  <div className="transction-ammount-inputs-wrapper">
                    <input
                      onChange={(e) => handleAmount(e, idx)}
                      type="number"
                      className={
                        "payment-inputsearch " +
                        (data?.isSave || data?.isOnline
                          ? "payment-input-disabled"
                          : "")
                      }
                      value={data?.amount}
                      placeholder="Amount"
                      disabled={data?.isSave || data?.isOnline}
                      onKeyDown={(e) =>
                        (e.key?.toLowerCase() === "e" ||
                          e.key === "+" ||
                          e.key === "-") &&
                        e.preventDefault()
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: multiplePaymentList?.length > 1 ? "57px" : "24px",
                    }}
                    className="payment-btn-container"
                  >
                    {(idx !== 0 ||
                      (idx == 0 && multiplePaymentList?.length > 1)) &&
                      !data?.isSave &&
                      !data?.isOnline && (
                        <div className="payment-delete-icon">
                          <img
                            alt="delete"
                            src={deleteIcon}
                            onClick={() => handleDeletePayment(idx)}
                          />
                        </div>
                      )}
                    <div
                      className={
                        "payment-add-icon " +
                        (filteredPaymentMethod?.length == 10
                          ? "payment-add-disbled"
                          : "")
                      }
                    >
                      {filteredPaymentMethod?.length - 1 == idx && (
                        <img
                          alt="add"
                          src={plusIcon}
                          onClick={handleAddPayment}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {refundAmount > 0 && (
          <div className="payment-method-type-wrapper">
            <div className="custom-payment-selector disable-select-container">
              <div className="search-wrapper">
                <input
                  type="text"
                  className="inputSearch disable-payment-input"
                  value="Refund"
                  readOnly
                  disabled={true}
                />
              </div>
            </div>
            <div className="transaction-amount-wrapper">
              <div className="transction-ammount-inputs-wrapper">
                <input
                  readOnly
                  type="text"
                  className="payment-inputsearch payment-input-disabled"
                  value=""
                  placeholder="Transaction ID"
                  disabled={true}
                />
              </div>
              <div className="amount-btns-wrapper">
                <div className="transction-ammount-inputs-wrapper">
                  <input
                    readOnly
                    type="number"
                    className="payment-inputsearch payment-input-disabled"
                    value={refundAmount}
                    disabled={true}
                  />
                </div>
                <div
                  style={{
                    width: multiplePaymentList?.length > 1 ? "57px" : "24px",
                  }}
                  className="payment-btn-container"
                ></div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const paymentMethodsUI = () => {
    return (
      <div className="payment-methods-container">
        <div>
          <p className="payment-method-heading">
            PAYMENT METHOD FOR AMOUNT TO BE PAID
          </p>
        </div>
        {paymentMethods()}
      </div>
    );
  };
  return (
    <>
      {
        // !hidePaymentMode &&
        paymentMethodsUI()
      }
    </>
  );
};
//export
export default PaymentMenthods;
